(function(){
  'use strict';
  const $ = (selector, root=document) => root.querySelector(selector);
  const $$ = (selector, root=document) => Array.from(root.querySelectorAll(selector));
  const isEnglish = () => ((document.documentElement.lang || 'ar').split('-')[0] === 'en');
  const text = (ar,en) => isEnglish() ? en : ar;

  function showToast(message, isError=false){
    const toast = $('[data-as2-toast]');
    if(!toast) return;
    toast.textContent = message;
    toast.classList.toggle('is-error', !!isError);
    toast.classList.add('is-visible');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(()=>toast.classList.remove('is-visible'), 2600);
  }

  function setCartCount(count){
    $$('[data-as2-cart-count]').forEach(el=>{
      el.textContent = String(count || 0);
      el.classList.toggle('is-empty', !count);
    });
  }

  async function getCart(){
    try{
      const response = await fetch('/cart.js', {headers:{Accept:'application/json'}});
      if(!response.ok) return null;
      return await response.json();
    }catch(e){ return null; }
  }

  async function addToCart(id, quantity=1){
    const response = await fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({id:Number(id),quantity:Number(quantity)||1})
    });
    const data = await response.json().catch(()=>({}));
    if(!response.ok) throw new Error(data.description || data.message || 'Unable to add product');
    const cart = await getCart();
    if(cart) setCartCount(cart.item_count);
    document.dispatchEvent(new CustomEvent('asnani:cart-updated',{detail:{cart,item:data}}));
    return data;
  }

  /* Header drawer */
  const drawer = $('[data-as2-drawer]');
  const drawerOverlay = $('[data-as2-drawer-overlay]');
  function toggleDrawer(open){
    if(!drawer || !drawerOverlay) return;
    drawer.classList.toggle('is-open', open);
    drawerOverlay.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('as2-lock', open);
  }
  document.addEventListener('click', e=>{
    if(e.target.closest('[data-as2-drawer-open]')) toggleDrawer(true);
    if(e.target.closest('[data-as2-drawer-close]') || e.target.closest('[data-as2-drawer-overlay]')) toggleDrawer(false);
  });
  document.addEventListener('keydown', e=>{ if(e.key === 'Escape'){ toggleDrawer(false); toggleWishlistDrawer(false); closeFilters(); } });

  /* Wishlist drawer */
  const wishlistDrawer = $('[data-as2-wishlist-drawer]');
  const wishlistOverlay = $('[data-as2-wishlist-overlay]');
  function toggleWishlistDrawer(open){
    if(!wishlistDrawer || !wishlistOverlay) return;
    wishlistDrawer.classList.toggle('is-open',open);
    wishlistOverlay.classList.toggle('is-open',open);
    wishlistDrawer.setAttribute('aria-hidden',open?'false':'true');
    document.body.classList.toggle('as2-lock',open);
  }
  document.addEventListener('click',e=>{
    if(e.target.closest('[data-as2-wishlist-drawer-open]')){ toggleDrawer(false); toggleWishlistDrawer(true); }
    if(e.target.closest('[data-as2-wishlist-drawer-close]') || e.target.closest('[data-as2-wishlist-overlay]')) toggleWishlistDrawer(false);
  });

  /* Collection filters */
  const filterPanel = $('[data-as2-filter-panel]');
  const filterOverlay = $('[data-as2-filter-overlay]');
  function toggleFilters(open){
    if(!filterPanel || !filterOverlay) return;
    filterPanel.classList.toggle('is-open',open);
    filterOverlay.classList.toggle('is-open',open);
    document.body.classList.toggle('as2-lock',open);
  }
  function closeFilters(){ toggleFilters(false); }
  document.addEventListener('click',e=>{
    if(e.target.closest('[data-as2-filter-open]')) toggleFilters(true);
    if(e.target.closest('[data-as2-filter-close]') || e.target.closest('[data-as2-filter-overlay]')) closeFilters();
  });
  $$('[data-as2-auto-submit]').forEach(select=>select.addEventListener('change',()=>select.form && select.form.submit()));

  /* Horizontal product rows */
  $$('[data-as2-slider]').forEach(slider=>{
    const track = $('[data-as2-slider-track]',slider);
    if(!track) return;
    const amount = ()=>Math.max(260, track.clientWidth * .78);
    $('[data-as2-slider-prev]',slider)?.addEventListener('click',()=>track.scrollBy({left:-amount(),behavior:'smooth'}));
    $('[data-as2-slider-next]',slider)?.addEventListener('click',()=>track.scrollBy({left:amount(),behavior:'smooth'}));
  });

  /* Product gallery */
  function setMainProductImage(url, thumb=null){
    if(!url) return;

    const gallery = thumb?.closest('[data-as2-product-gallery]') || $('[data-as2-product-gallery]');
    const main = gallery ? $('#As2MainProductImage', gallery) : $('#As2MainProductImage');
    if(!main) return;

    /*
      Shopify image_tag creates srcset/sizes. Changing src alone is not enough,
      because the browser may continue displaying the old currentSrc from srcset.
    */
    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    main.srcset = '';
    main.src = String(url);

    if(thumb){
      $$('[data-as2-product-thumb]', gallery).forEach(el=>{
        const active = el === thumb;
        el.classList.toggle('is-active', active);
        el.setAttribute('aria-current', active ? 'true' : 'false');
      });

      thumb.scrollIntoView({
        behavior:'smooth',
        block:'nearest',
        inline:'center'
      });
    }
  }

  function activateProductThumb(thumb){
    if(!thumb || !thumb.dataset.image) return;
    setMainProductImage(thumb.dataset.image, thumb);
  }

  document.addEventListener('click',e=>{
    const thumb = e.target.closest('[data-as2-product-thumb]');
    if(!thumb) return;
    e.preventDefault();
    activateProductThumb(thumb);
  });

  /* Swipe the main product image on touch devices */
  const gallerySwipeStart = new WeakMap();

  document.addEventListener('touchstart',e=>{
    const media = e.target.closest('.as2-product-main-media');
    if(!media || !media.closest('[data-as2-product-gallery]')) return;
    const touch = e.changedTouches?.[0];
    if(!touch) return;
    gallerySwipeStart.set(media,{x:touch.clientX,y:touch.clientY});
  },{passive:true});

  document.addEventListener('touchend',e=>{
    const media = e.target.closest('.as2-product-main-media');
    const gallery = media?.closest('[data-as2-product-gallery]');
    if(!media || !gallery) return;

    const start = gallerySwipeStart.get(media);
    const touch = e.changedTouches?.[0];
    gallerySwipeStart.delete(media);
    if(!start || !touch) return;

    const dx = touch.clientX - start.x;
    const dy = touch.clientY - start.y;

    /* Ignore vertical page scrolling and very short movements */
    if(Math.abs(dx) < 45 || Math.abs(dx) <= Math.abs(dy)) return;

    const thumbs = $$('[data-as2-product-thumb]',gallery);
    if(thumbs.length < 2) return;

    let index = thumbs.findIndex(el=>el.classList.contains('is-active'));
    if(index < 0) index = 0;

    /*
      Swipe left = next image.
      Swipe right = previous image.
    */
    const nextIndex = dx < 0
      ? (index + 1) % thumbs.length
      : (index - 1 + thumbs.length) % thumbs.length;

    activateProductThumb(thumbs[nextIndex]);
  },{passive:true});

  /* Quantity */
  document.addEventListener('click',e=>{
    const wrap = e.target.closest('[data-as2-quantity]');
    if(!wrap) return;
    const input = $('input[name="quantity"]',wrap);
    if(!input) return;
    let value = Math.max(1,parseInt(input.value||'1',10)||1);
    if(e.target.closest('[data-as2-qty-minus]')) value=Math.max(1,value-1);
    if(e.target.closest('[data-as2-qty-plus]')) value+=1;
    input.value=value;
  });

  /* Variant updates */
  document.addEventListener('change',e=>{
    const select=e.target.closest('[data-as2-variant-select]');
    if(!select) return;
    const option=select.options[select.selectedIndex];
    const price=$('[data-as2-product-price]');
    const compare=$('[data-as2-product-compare]');
    const add=$('[data-as2-product-add]');
    const image=$('#As2MainProductImage');
    const available=option?.dataset.available === 'true';
    if(price && option?.dataset.price) price.textContent=option.dataset.price;
    if(compare){
      if(option?.dataset.compare){ compare.textContent=option.dataset.compare; compare.hidden=false; }
      else { compare.textContent=''; compare.hidden=true; }
    }
    if(image && option?.dataset.image){
      const gallery = image.closest('[data-as2-product-gallery]');
      const matchingThumb = gallery
        ? $$('[data-as2-product-thumb]',gallery).find(thumb=>thumb.dataset.image === option.dataset.image)
        : null;

      if(matchingThumb) activateProductThumb(matchingThumb);
      else setMainProductImage(option.dataset.image);
    }
    if(add){
      add.disabled=!available;
      const ar=$('[data-lang="ar"]',add), en=$('[data-lang="en"]',add);
      if(ar) ar.textContent=available?'أضف إلى السلة':'غير متوفر';
      if(en) en.textContent=available?'Add to cart':'Sold out';
    }
  });

  /* Quick add cards */
  document.addEventListener('submit',async e=>{
    const form=e.target.closest('[data-as2-quick-form]');
    if(!form) return;
    e.preventDefault();
    const button=$('button[type="submit"]',form);
    const id=$('[name="id"]',form)?.value;
    if(!id) return;
    button?.classList.add('is-loading');
    if(button) button.disabled=true;
    try{
      await addToCart(id,1);
      showToast(text('تمت إضافة المنتج إلى السلة','Product added to cart'));
    }catch(err){ showToast(err.message || text('تعذر إضافة المنتج','Unable to add product'),true); }
    finally{ button?.classList.remove('is-loading'); if(button) button.disabled=false; }
  });

  /* Main product add */
  document.addEventListener('submit',async e=>{
    const form=e.target.closest('[data-as2-product-form]');
    if(!form) return;
    e.preventDefault();
    const add=$('[data-as2-product-add]',form);
    const id=$('[name="id"]',form)?.value;
    const qty=$('[name="quantity"]',form)?.value || 1;
    const message=$('[data-as2-product-message]',form);
    if(!id || add?.disabled) return;
    if(add) add.disabled=true;
    try{
      await addToCart(id,qty);
      if(message){ message.hidden=false; message.classList.remove('is-error'); message.textContent=text('تمت إضافة المنتج إلى السلة بنجاح.','Product added to cart successfully.'); }
      showToast(text('تمت إضافة المنتج إلى السلة','Product added to cart'));
    }catch(err){
      if(message){ message.hidden=false; message.classList.add('is-error'); message.textContent=err.message || text('تعذر إضافة المنتج.','Unable to add product.'); }
      showToast(err.message || text('تعذر إضافة المنتج','Unable to add product'),true);
    }finally{ if(add) add.disabled=false; }
  });

  /* Wishlist, stored locally in the browser */
  const WISHLIST_KEY='asnani_wishlist_v2';
  function readWishlist(){
    try{ const data=JSON.parse(localStorage.getItem(WISHLIST_KEY)||'[]'); return Array.isArray(data)?data:[]; }catch(e){ return []; }
  }
  function writeWishlist(items){
    localStorage.setItem(WISHLIST_KEY,JSON.stringify(items));
    syncWishlistUI(items);
  }
  function safe(value){ return String(value||'').replace(/[&<>'"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c])); }
  function syncWishlistUI(items=readWishlist()){
    const handles=new Set(items.map(item=>item.handle));
    $$('[data-as2-wishlist-toggle]').forEach(button=>button.classList.toggle('is-active',handles.has(button.dataset.productHandle)));
    $$('[data-as2-wishlist-count]').forEach(el=>{el.textContent=items.length;el.classList.toggle('is-empty',items.length===0);});
    renderWishlist(items);
    renderWishlistDrawer(items);
  }
  function renderWishlistDrawer(items=readWishlist()){
    const list=$('[data-as2-wishlist-drawer-list]');
    const empty=$('[data-as2-wishlist-drawer-empty]');
    if(!list) return;
    list.innerHTML='';
    if(empty) empty.hidden=items.length>0;
    items.forEach(item=>{
      const row=document.createElement('article');
      row.className='as2-wishlist-drawer-item';
      row.innerHTML=`<a href="${safe(item.url)}">${item.image?`<img src="${safe(item.image)}" alt="${safe(item.title)}" loading="lazy">`:''}</a><div><h4><a href="${safe(item.url)}">${safe(item.title)}</a></h4><strong>${safe(item.price)}</strong></div><button type="button" data-as2-wishlist-remove="${safe(item.handle)}" aria-label="Remove">×</button>`;
      list.appendChild(row);
    });
  }

  function renderWishlist(items=readWishlist()){
    const grid=$('[data-as2-wishlist-grid]');
    const empty=$('[data-as2-wishlist-empty]');
    if(!grid) return;
    grid.innerHTML='';
    if(empty) empty.hidden=items.length>0;
    if(!items.length) return;
    items.forEach(item=>{
      const article=document.createElement('article');
      article.className='as2-wishlist-item';
      article.innerHTML=`<a class="as2-wishlist-item-image" href="${safe(item.url)}">${item.image?`<img src="${safe(item.image)}" alt="${safe(item.title)}" loading="lazy">`:''}</a><div class="as2-wishlist-item-body"><h3><a href="${safe(item.url)}">${safe(item.title)}</a></h3><strong>${safe(item.price)}</strong><div class="as2-wishlist-item-actions"><a href="${safe(item.url)}">${text('عرض المنتج','View product')}</a><button class="as2-wishlist-remove" type="button" data-as2-wishlist-remove="${safe(item.handle)}" aria-label="Remove">×</button></div></div>`;
      grid.appendChild(article);
    });
  }
  document.addEventListener('click',e=>{
    const button=e.target.closest('[data-as2-wishlist-toggle]');
    if(button){
      const handle=button.dataset.productHandle;
      if(!handle) return;
      const items=readWishlist();
      const index=items.findIndex(item=>item.handle===handle);
      if(index>=0){ items.splice(index,1); showToast(text('تمت إزالة المنتج من المفضلة','Removed from wishlist')); }
      else{
        items.unshift({handle,title:button.dataset.productTitle||'',url:button.dataset.productUrl||'',image:button.dataset.productImage||'',price:button.dataset.productPrice||''});
        showToast(text('تم حفظ المنتج في المفضلة','Saved to wishlist'));
      }
      writeWishlist(items.slice(0,60));
    }
    const remove=e.target.closest('[data-as2-wishlist-remove]');
    if(remove){ writeWishlist(readWishlist().filter(item=>item.handle!==remove.dataset.as2WishlistRemove)); }
  });

  document.addEventListener('DOMContentLoaded',()=>{
    syncWishlistUI();
    getCart().then(cart=>{if(cart)setCartCount(cart.item_count);});
  });
  syncWishlistUI();
})();
